import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ScrollableContainer, TableContainer } from "./style";
import { ImageUrl } from "../../../utils/constants";
import { NameInitials } from "../../Manager/styles";
import { cleanUpCommas, getInitials } from "../../../utils/methods";


const CommonTable = ({ title, headers, data=[], showAll, handleShowMore,imageBaseUrl,isPadding,hideHeaders,/*headersSpacing*/ }) => {
 
  useEffect(()=>{},[])

  return(
    <TableContainer hideHeaders={hideHeaders} isPadding={isPadding}>
      <div className="heading">{title}</div>
      {!hideHeaders && headers.length > 0 && (
        <div className="type">
          {headers.map((header, index) => (
            <div className="name" key={index}>{header}</div>
          ))}
        </div>
      )}
      <ScrollableContainer height={showAll ? "380px" : "380px"} showAllRows={showAll}>
        {data.length > 0 ? (data.slice(0, showAll ? data.length : 5).map((item, index) => (
          <div className="item" key={index}>
            <div className="item-left">
              { imageBaseUrl ? 
                item?.image !== "profile-Image/default.png" ? ( <div className="profile"> <img src={`${ImageUrl}/${item.image}`} alt={"profile-image"}/> </div> ):
                  <NameInitials id="name-initials">
                    {getInitials(item?.name)}
                  </NameInitials>  
                : null}
              <div className="name">{cleanUpCommas(item?.name)}</div>
            </div>
            <div className="value">{item?.total_posts}</div>
          </div>
        ))): (<div className="no-data">No Data Found</div>)}
      </ScrollableContainer>
      {data.length > 5 && !showAll && (
        <div className="showmore">
          <div className="button" onClick={handleShowMore}>
            Show More
          </div>
        </div>
      )}
    </TableContainer>)
}

CommonTable.propTypes = {
  title: PropTypes.string.isRequired,
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  showAll: PropTypes.bool,
  isPadding: PropTypes.bool,
  handleShowMore: PropTypes.func.isRequired,
  imageBaseUrl: PropTypes.bool.isRequired,
  hideHeaders: PropTypes.bool, 
};

export default CommonTable;   
